module.exports = __webpack_public_path__ + "img/no-data_search.9e165664.svg";